import { createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-label-group position-relative" }
const _hoisted_2 = ["name"]
const _hoisted_3 = { class: "crm:mt-4" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "text-center pt-2"
}
const _hoisted_6 = {
  key: 1,
  class: "crm:flex crm:flex-col crm:items-center crm:py-4 crm:justify-center crm:text-center"
}
const _hoisted_7 = { class: "dropzone-area__text crm:flex crm:flex-col crm:lg:flex-row crm:justify-center crm:items-center" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "form-label-group--active" }
const _hoisted_10 = { key: 0 }

import {reactive, computed, inject, toRefs} from 'vue'
import useFileUploader from "../composable/useFileUploader";
import Ajax from 'fallco-frontend-framework/src/js/libs/ajax/index.js';
import {httpPost} from 'fallco-frontend-framework/src/js/classes/HttpManager/http_caller.js'
import BaseLoader from 'fallco-frontend-framework/src/vue/plugins/BaseLoader/BaseLoader.vue'
import {createPluginInstance} from '../core/plugins/create-dynamic-instance.js'
import {useChecklistStore, usePraticaStore} from "../store/crm.store";
import {upload} from '../svg/svgs.js'


const __default__ = {
  name: 'BaseInputFile'
}

export default /*@__PURE__*/Object.assign(__default__, {
  props: {
  /**
   * ID del campo utilizzato nel jSON
   */
  fieldId: {
    type: [String, Number],
    default: null
  },
  /**
   * label del campo
   */
  label: {
    type: String,
    default: ''
  },
  /**
   * Stato del campo
   * Valori Accettati:
   * - readonly | disabled | active | ...
   */
  state: {
    type: String,
    default: null
  },
  /**
   * Nome/ID del campo
   */
  name: {
    type: String,
    default: ''
  },
  /**
   * se true al caricamento di un file verrà scaturito un upload automatico
   */
  immediateUpload: {
    type: Boolean,
    default: false
  },
  /**
   * oggetto di estensioni accettate
   */
  extensionAccepted: {
    type: Array,
    default: null
  },
  /**
   * estensione max accettata per singolo file
   */
  maxSizeAccepted: {
    type: [Number, String],
    default: null
  },
  /**
   * Numero massimo di file importabili
   */
  maxFileNumber: {
    type: Number,
    default: 0
  },
  /**
   * Oggetto Completo inclusivo di eventuali required, type e options
   */
  validateTo: {
    type: [Object, Array],
    default() {
      return {}
    }
  },
  /**
   * Valore da settare per la validazion/required
   */
  value: {
    type: [Array, Object],
    default() {
      return {}
    }
  },
  /**
   * Oggetto di dati aggiuntivi da aggiungere al post col file
   */
  additionalData: {
    type: [Object, Array],
    default() {
      return []
    }
  },
  /**
   * Opzioni per le chiamate post
   */
  httpOptions: {
    type: [Object, Array],
    default() {
      return []
    }
  }
},
  emits: [
  'update:value',
  'fileCaricati',
  'afterDeleteFile'
],
  setup(__props, { emit: __emit }) {

/**
 * @doc Renderizza e gestisce un input file con un sistema di drag and drop.
 */
const $L_ = inject('$L_');
const props = __props
const emits = __emit

const praticaStore = usePraticaStore();
const checklistStore = useChecklistStore();

const {addObjectProperties, composeFileObject, composeFileToUpload, processFile} = useFileUploader(props, emits)

const uploader = reactive({
  filesUploaded: [],
  filesRejected: [],
  filesEmpty: [],
  dragging: false,
  dragCounter: 0,
  progressSize: {}
})

const filesUploadedLength = computed(() => {
  return (uploadedFiles.value) ? (uploadedFiles.value).length : 0;
})

const estensioniAccettate = (props.extensionAccepted) ? props.extensionAccepted.join(' | ') : null;

const {filesUploaded} = toRefs(uploader)


const uploadedFiles = computed({
  get: () => {
    return composeFileObject($L_.cloneDeep(props.value));
  },
  set: (value) => {
    emits('update:value', value)
  }
})

/**
 * Se non stiamo inviando i file con immediate post esegue la cancellazione parsando l'oggetto dei file
 * @param nomeFile
 * @private
 */
function _cancellaFileNoImmediatePost(nomeFile) {
  let fileTrovato = false;
  let filesCaricati = $L_.cloneDeep(uploadedFiles.value)
  const fileIndex = filesCaricati.findIndex((file) => file.nome_file === nomeFile);
  if(fileIndex !== -1) {
    filesCaricati.splice(fileIndex, 1)
    uploadedFiles.value = filesCaricati;
    fileTrovato = true;
  }

  if(!fileTrovato) {
    let filesRigettati = $L_.cloneDeep(uploader.filesRejected)
    const fileIndex = filesRigettati.findIndex((file) => file.nome_file === nomeFile);
    if(fileIndex !== -1) {
      filesRigettati.splice(fileIndex, 1);
      uploader.filesRejected = filesRigettati;
    }
  }
}

/**
 * Cancella il file precedentemente mandato via post
 * @param type
 * @param index
 * @return {Promise<void>}
 * @private
 */
async function _cancellaFileImmediatePost(type, index) {
  if (type === 'accepted' && uploadedFiles.value.length > 0) {
    let setDeleteFiles = await httpPost(props.httpOptions.remove.module, props.httpOptions.remove.action, {
      questionario_id: parseInt(props.additionalData.questionario_id),
      documento_id: parseInt(uploadedFiles.value[index].documento_id),
      pratica_id: parseInt(praticaStore.praticaID)
    });

    if(setDeleteFiles.esito === 'ok') {
      let listaFiles = $L_.cloneDeep(uploadedFiles.value)
      listaFiles.splice(index, 1);
      uploadedFiles.value = listaFiles;
    }
  } else if (type === 'rejected') {
    if (index > -1) {
      uploader.filesRejected.splice(index, 1);
    }
  }
}

/**
 * @param index
 * @param type
 * @param nomeFile
 * @returns {Promise<void>}
 */
const cancellaFile = async (index, type, nomeFile) => {
  if ((uploadedFiles.value[index] && uploadedFiles.value[index].documento_id) || props.immediateUpload) {
    _cancellaFileImmediatePost(type, index);
  } else {
    _cancellaFileNoImmediatePost(nomeFile);
  }

  const reload_checklist_instance = createPluginInstance(BaseLoader)
  reload_checklist_instance.mount.show();
  setTimeout(() => {
    checklistStore.onControlloDisabilitaPerCtaCompletaValidazione();
    emits('afterDeleteFile')
    reload_checklist_instance.mount.hide();
    reload_checklist_instance.app.unmount();
  }, 2000)
}

/**
 * @param index
 * @param type
 */
const downloadFile = (index, type) => {
  if (type === 'accepted' && uploadedFiles.value.length > 0) {
    let composeUrl = `./download?documento_id=${uploadedFiles.value[index].documento_id}&questionario_id=${props.additionalData.questionario_id}&pratica_id=${praticaStore.praticaID}`;
    Ajax.download_file(composeUrl)
  } else if (type === 'rejected' && uploader.filesRejected.length > 0) {
    if (index > -1) {
      uploader.filesRejected.splice(index, 1);
    }
  }
}

/**
 * @param isValid
 * @returns {string}
 */
const setType = (isValid) => { return (isValid) ? 'success' : 'error'}

/**
 * Esegue il post di un file singolo
 * @param file
 * @returns {Promise<void>}
 */
const postSingleFile = async (file) => {
  let formData = await composeFileToUpload(file, $L_.cloneDeep(props.additionalData));
  formData.append('pratica_id', praticaStore.praticaID)
  uploadedFiles.value.push(addObjectProperties(file));
  let indiceDelFileAppenaCaricato = uploadedFiles.value.length - 1;
  uploader.progressSize[file.nome_file] = 1;

  let setSaveFiles = await httpPost(
      'Questionario',
      'saveQuestionarioFiles',
      formData,
      {headers: {"Content-Type": "multipart/form-data"}, messages: 'error'},
      function(progressEvent) {
        const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
        if (totalLength !== null) {
          uploader.progressSize[file.nome_file] = (Math.round( (progressEvent.loaded * 100) / totalLength ));
        }
      }
  )

  delete uploadedFiles.value[indiceDelFileAppenaCaricato]

  let responseFile = setSaveFiles.files[Object.keys(setSaveFiles.files)[0]][0];
  if(setSaveFiles.esito === 'ko') {
    responseFile.validate = false;
    responseFile.message = responseFile.error;
    uploader.filesRejected.push(addObjectProperties(responseFile));
  } else {
    responseFile.bozza = '1';
    uploadedFiles.value.push(addObjectProperties(responseFile));
    emits('update:value', uploadedFiles.value)
  }

  setTimeout(async function () {
    let uploadFilesNoEmpty = $L_.cloneDeep(uploadedFiles.value);
    uploadFilesNoEmpty = uploadFilesNoEmpty.filter((item) => item.filesystem_name !== null);
    //acquisisce le note inserite precedentemente l'inserimento del file e gliele passa
    uploadFilesNoEmpty[0].note = uploadedFiles.value[0].note;
    await checklistStore.onControlloDisabilitaPerCtaCompletaValidazione();
    uploader.progressSize[file.nome_file] = 0;
    uploadedFiles.value = $L_.cloneDeep(uploadFilesNoEmpty);
    emits('update:value', uploadFilesNoEmpty)
  }, 2000);
}

/**
 * Ripulisce il nome di caratteri speciali e spazi
 * @param name
 * @return {string}
 */
const clearInputNameSpecialCharachters = (name) => name.toString().replaceAll(' ', '').replace(/[^a-zA-Z0-9]/g, "");

const inputFileClassName = 'js-input-file-' + clearInputNameSpecialCharachters(props.name)

/**
 * Cicla tutti i file, li valida, e li smista negli oggetti corrispondenti
 * Se il baseInputFile ha props.immediateUpload a true, esegue una chiamata Ajax per il post del file
 * @param event
 * @param type
 */
const uploadFiles = (event, type = 'drop') => {
  uploader.dragCounter = 0;
  uploader.dragging = false;
  let droppedFiles = (type === 'drop') ? event.dataTransfer.files : (document.querySelector('.'+inputFileClassName)).files;

  let fileValidatiECaricati = props.value;
  ([...droppedFiles]).forEach(function (file) {
    let fileValidato = processFile(
        file,
        {
          immediateUploads: props.immediateUpload,
          extensionAccepted: props.extensionAccepted,
          maxSizeAccepted: props.maxSizeAccepted,
          maxFileNumber: props.maxFileNumber
        },
        props.additionalData,
        uploadedFiles.value,
        uploader.filesRejected
    );
    if (fileValidato.status) {
      if (props.immediateUpload) {
        postSingleFile(file);
      } else {
        fileValidatiECaricati.push(fileValidato.file);
      }
    } else {
      uploader.filesRejected.push(file);
    }
  })
  uploadedFiles.value = fileValidatiECaricati;
}

/**
 * gestisce il click per aprire il file manager
 */
const openUploadWindow = () => {
  document.querySelector('.'+inputFileClassName).click();
}

/**
 * Gestisce i drag hover enter e leave
 * @param status
 */
const dragToggle = (status) => {
  if(status) {
    uploader.dragCounter++;
    uploader.dragging = status;
  }

  if(!status) {
    uploader.dragCounter--;
  }

  if (!status && uploader.dragCounter === 0) {
    uploader.dragging = status;
}
}

return (_ctx, _cache) => {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createCommentVNode(" input file "),
      _withDirectives(_createElementVNode("input", {
        type: "file",
        name: __props.name,
        ref: "uploadfile",
        class: _normalizeClass(inputFileClassName),
        onChange: _cache[0] || (_cache[0] = $event => (uploadFiles($event,'input')))
      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2), [
        [_vShow, false]
      ]),
      _createCommentVNode("DropZone "),
      _createElementVNode("div", {
        class: _normalizeClass(["d-flex flex-column justify-content-center js-dragzone", {'drag-active': uploader.dragging,'v-required': __props.state!== 'readonly' && __props.validateTo.required && (filesUploadedLength.value < 1 || filesUploadedLength.value === undefined), 'form-control form-control--uploadFile dropzone-area':__props.state !== 'readonly'}]),
        onDrop: _cache[2] || (_cache[2] = _withModifiers($event => (uploadFiles($event,'drop')), ["prevent"])),
        onDragenter: _cache[3] || (_cache[3] = $event => (dragToggle(true))),
        onDragleave: _cache[4] || (_cache[4] = $event => (dragToggle(false))),
        onDragover: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default", {
            filesUploaded: uploadedFiles.value,
            filesRejected: uploader.filesRejected,
            cancellaFile: cancellaFile,
            downloadFile: downloadFile,
            progressSize: uploader.progressSize
          })
        ]),
        (!uploadedFiles.value || uploadedFiles.value && uploadedFiles.value.length < 1 || !__props.value[0].filesystem_name)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (__props.state === 'readonly')
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("i", null, "Nessun file caricato al momento", -1 /* CACHED */)
                  ]))]))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true),
        (__props.state !== 'readonly')
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_base_icon, {
                  icon: _unref(upload),
                  class: "crm:lg:mr-2"
                }, null, 8 /* PROPS */, ["icon"]),
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "crm:inline-block crm:lg:mr-1" }, "Trascina qui i file da allegare, oppure", -1 /* CACHED */)),
                _createElementVNode("span", {
                  class: "c-pointer dropzone-area__text__link",
                  onClick: _cache[1] || (_cache[1] = $event => (openUploadWindow()))
                }, "seleziona il file")
              ]),
              (_unref(estensioniAccettate))
                ? (_openBlock(), _createElementBlock("small", _hoisted_8, "(File Supportati: " + _toDisplayString(_unref(estensioniAccettate)) + ")", 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true)
      ], 34 /* CLASS, NEED_HYDRATION */),
      (__props.state !== 'readonly')
        ? (_openBlock(), _createBlock(_Transition, {
            key: 0,
            name: "slide-fade"
          }, {
            default: _withCtx(() => [
              _createElementVNode("label", _hoisted_9, [
                _createTextVNode(_toDisplayString(__props.label) + " ", 1 /* TEXT */),
                (__props.maxFileNumber)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Numero Massimo di File: " + _toDisplayString(__props.maxFileNumber), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

})